import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Practitioner } from '../models/practitioner.model';
import { PractitionerService } from '../services/practitioner.service';
import { PractitionerStatus } from '../enums/practitioner-status.enum';

@Injectable()
export class RegisterGuard implements CanActivate {

  constructor(private practitionerService: PractitionerService){}

  canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot): boolean | Promise<boolean> | Observable<boolean | UrlTree> {
    var id = route.params['id'];
    return new Promise<boolean>((resolve, reject) => {
      this.practitionerService.getPractitioner(id).subscribe((practitioner: Practitioner) => {
        if (practitioner.status === PractitionerStatus.Approved) {
          resolve(true);
        }
        resolve(false);
      }, error => {
        reject(error);
      });
    });
  }
}
